<label class="common-checkbox" [class]="computedClass()" [class.disabled]="disabled">
  <input
    class="checkbox"
    type="checkbox"
    [attr.aria-label]="ariaLabel"
    [checked]="checked()"
    [disabled]="disabled"
    (change)="onModelChange($event)" />
  <span class="checkmark" [class.checkmark--checked]="checked()"></span>
  <ng-content />
</label>
